import { scaleLinear, scaleSqrt } from 'd3-scale';

export default {
	x: scaleLinear,
	y: scaleLinear,
	z: scaleLinear,
	r: scaleSqrt
};
